const API_BASE_URL = "https://zhasylzhelken.kz/api";
// const API_BASE_URL = "http://localhost:8080/api";
export default API_BASE_URL;